import { AnchorHTMLAttributes, ElementType, PropsWithChildren } from 'react';
import Link from 'next/link';
import { clsx } from 'clsx';

import { adjustPathname } from '@monoimin/utils/helpers';

import { LinkFullSizeOverlay } from './LinkFullSizeOverlay';

interface LinkWrapperProps {
  url?: string | undefined;
  className?: string;
  as?: string;
  target?: AnchorHTMLAttributes<never>['target'];
  fullSizeOverlay?: boolean;
}

export function LinkWrapper({
  url,
  children,
  className,
  as,
  target,
  fullSizeOverlay,
}: PropsWithChildren<LinkWrapperProps>) {
  const Component = (as ?? 'div') as ElementType;
  if (!url) {
    return <Component className={className}>{children}</Component>;
  }

  const isExternal = url?.startsWith(`http`);
  const finalUrl = url.includes('#') ? url : adjustPathname(url);
  if (isExternal) {
    return (
      <a
        target={target || '_blank'}
        href={finalUrl}
        rel='noopener noreferrer'
        className={clsx(className, 'block cursor-pointer')}
      >
        {children}
        {fullSizeOverlay && <LinkFullSizeOverlay />}
      </a>
    );
  }
  return (
    <Link
      target={target || '_blank'}
      href={finalUrl}
      className={clsx(className, 'block cursor-pointer')}
    >
      {children}
      {fullSizeOverlay && <LinkFullSizeOverlay />}
    </Link>
  );
}
